import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { categories } from '../../data/products';
import './Categories.css';

const Categories = () => {
  const trendingItems = ['Dresses', 'Sneakers', 'Handbags', 'Watches', 'Sunglasses', 'Perfumes', 'Activewear', 'Swimwear'];

  return (
    <section className="categories">
      <div className="categories-header">
        <h2 className="categories-title">Shop by Category</h2>
        <p className="categories-subtitle">Explore our wide selection of products</p>
      </div>

      <div className="categories-grid">
        {categories.map((category) => (
          <Link key={category.id} to={`/category/${category.id}`} className="category-card">
            <img src={category.image} alt={category.name} className="category-card-image" />
            <div className="category-card-overlay">
              <h3 className="category-card-name">{category.name}</h3>
              <p className="category-card-count">{category.count.toLocaleString()}+ items</p>
              <span className="category-card-arrow">Shop Now <ArrowRight size={14} /></span>
            </div>
          </Link>
        ))}
      </div>

      <div className="categories-featured">
        <h3 className="categories-featured-title">Trending Now</h3>
        <div className="categories-featured-row">
          {trendingItems.map((item, index) => (
            <Link key={item} to={`/shop?search=${item}`} className="category-featured-card">
              <img src={`https://picsum.photos/200/200?random=${index + 1}`} alt={item} className="category-featured-image" />
              <p className="category-featured-name">{item}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
